import NotFound from '@/pages/NotFound';
import Layout from '@/pages/layout/index';
// import Organization from '@/pages/Organization';
// import User from '@/pages/User';
import Member from '@/pages/Member';
import Permission from '@/pages/Permission';
import Service from '@/pages/Service';
import Teams from '@/pages/Teams';

const routes = [];

routes.push(
  {
    path: '*',
    component: NotFound,
  },
  {
    path: '/',
    redirect: '/member',
    component: Layout,
  },
  {
    path: '/',
    meta: { scrollToTop: true },
    component: Layout,
    children: [
      // {
      //   path: '/organization',
      //   name: 'Organization',
      //   component: Organization,
      // },
      {
        path: '/member',
        name: 'Member',
        component: Member,
      },
      {
        path: '/permission',
        name: 'Permission',
        component: Permission,
      },
      {
        path: '/service',
        name: 'Service',
        component: Service,
      },
      {
        path: '/teams',
        name: 'Teams',
        component: Teams,
      },
      // {
      //   path: '/user',
      //   name: 'User',
      //   component: User,
      // },
    ],
  },

  // {
  //   path: '/organization',
  //   meta: { scrollToTop: true },
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'Organization',
  //       component: Organization,
  //     },
  //   ],
  // },
  // {
  //   path: '/user',
  //   meta: { scrollToTop: true },
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'User',
  //       component: User,
  //     },
  //   ],
  // },
  // {
  //   path: '/member',
  //   meta: { scrollToTop: true },
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'Member',
  //       component: Member,
  //     },
  //   ],
  // },
  // {
  //   path: '/permission',
  //   meta: { scrollToTop: true },
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'Permission',
  //       component: Permission,
  //     },
  //   ],
  // },
  // {
  //   path: '/setup',
  //   meta: { scrollToTop: true },
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'setup',
  //       component: Setup,
  //     },
  //   ],
  // },
);

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js